var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    opacity: 0.4,
    d: "M15.0216 6.99023C17.0641 6.99023 18.7266 8.70673 18.7266 10.8164V15.01C18.7266 17.1146 17.0682 18.8267 15.0299 18.8267H5.76656C3.72323 18.8267 2.0599 17.1111 2.0599 15.0014V10.8078C2.0599 8.70329 3.71906 6.99023 5.75823 6.99023H6.54156L15.0216 6.99023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M10.8495 14.2753L13.2736 11.802C13.5236 11.5464 13.5236 11.1351 13.272 10.8803C13.0203 10.6264 12.6145 10.6272 12.3645 10.882L11.037 12.2363L11.037 3.64589C11.037 3.28616 10.7495 2.99414 10.3945 2.99414C10.0403 2.99414 9.75365 3.28616 9.75365 3.64589L9.75365 12.2363L8.42531 10.882C8.17531 10.6272 7.76948 10.6264 7.51781 10.8803C7.39198 11.0081 7.32865 11.1748 7.32865 11.3424C7.32865 11.5083 7.39198 11.6751 7.51615 11.802L9.94031 14.2753C10.0611 14.398 10.2245 14.4674 10.3945 14.4674C10.5653 14.4674 10.7286 14.398 10.8495 14.2753Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletDownload);
export default __webpack_public_path__ + "static/media/wallet-download.b7471390a81be64adfb893be7f74c8ae.svg";
export { ForwardRef as ReactComponent };